<template>
	<div class="c-base-input-search">
		<input
			v-model="currentInput"
			type="search"
			class="
				relative
				border-2 border-black
				rounded-26
				>=1024:rounded-32
				font-darker-grotesque font-medium
				w-full
				text-text-placeholder text-input
				pl-lg
				pb-6
				h-full
			"
			style="height: 1em"
			v-bind="$attrs"
			@input="() => $emit('input', currentInput)"
			@keydown.enter="() => $emit('search', currentInput)"
		/>
		<button
			class="
				absolute
				right-xl
				>=768:right-lg
				top-1/2
				transform
				-translate-y-1/2
			"
			aria-label="udfør søgning"
			@click="() => $emit('search', currentInput)"
		>
			<SvgIconSearch class="w-16 h-16" />
		</button>
	</div>
</template>

<script>
import SvgIconSearch from '~/assets/svgs/icon-search.svg?inline';

export default {
	name: 'BaseInputSearch',
	components: {
		SvgIconSearch,
	},
	inheritAttrs: false,
	props: {
		value: String,
	},
	data() {
		return {
			currentInput: this.value,
		};
	},

	watch: {
		currentInput() {
			this.$emit('input', this.currentInput);
		},
		value() {
			this.currentInput = this.value;
		},
	},
};
</script>
<style lang="postcss">
.c-base-input-search {
	@apply relative h-48 >=1024:h-64;
}
</style>
